// DealBanner.tsx — Full-width deal-of-the-day banner with mock countdown timer.
// TODO(deals-api-PR): Wire to real GET /deals/featured when deals BE lands.

import { useEffect, useState } from 'react';
import { notYetWiredToast } from '@/components/primitives';

const F = '"Inter Variable","Inter",system-ui,sans-serif';
const DISPLAY = '"Fraunces Variable","Fraunces",Georgia,serif';

function useCountdown(totalSeconds: number) {
  const [remaining, setRemaining] = useState(totalSeconds);

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(s => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const h = Math.floor(remaining / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  return { h, m, s };
}

function Digit({ value, label }: { value: number; label: string }) {
  const str = String(value).padStart(2, '0');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{
        fontFamily: DISPLAY,
        fontSize: 'clamp(36px,4vw,56px)',
        fontWeight: 500,
        lineHeight: 1,
        letterSpacing: -0.03,
        color: '#E8441A',
      }}>{str}</div>
      <div style={{
        fontFamily: F,
        fontSize: 10,
        letterSpacing: 2,
        fontWeight: 700,
        color: 'rgba(232,68,26,0.6)',
        marginTop: 4,
        textTransform: 'uppercase',
      }}>{label}</div>
    </div>
  );
}

function Colon() {
  return (
    <div style={{
      fontFamily: DISPLAY,
      fontSize: 'clamp(36px,4vw,56px)',
      fontWeight: 500,
      lineHeight: 1,
      color: '#E8441A',
      opacity: 0.5,
      padding: '0 4px',
      marginBottom: 16,
    }}>:</div>
  );
}

export function DealBanner() {
  // 25h 30m 42s remaining (mock)
  const { h, m, s } = useCountdown(25 * 3600 + 30 * 60 + 42);

  return (
    <div style={{ padding: '0 clamp(16px, 4vw, 64px) 0' }}>
      <div style={{
        borderRadius: 32,
        overflow: 'hidden',
        position: 'relative',
        background: '#FFF1EC',
        border: '1px solid rgba(232,68,26,0.15)',
      }}>
        {/* Background decoration */}
        <div style={{
          position: 'absolute',
          top: -120, right: -120,
          width: 500, height: 500,
          background: 'radial-gradient(circle, rgba(232,68,26,0.12) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}/>
        <div style={{
          position: 'absolute',
          bottom: -80, left: -80,
          width: 300, height: 300,
          background: 'radial-gradient(circle, rgba(245,166,35,0.1) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}/>

        <div style={{
          position: 'relative',
          padding: 'clamp(24px, 4vw, 48px) clamp(20px, 4vw, 56px)',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 'clamp(20px, 3vw, 48px)',
        }}>
          {/* Left: copy */}
          <div style={{ flex: 1 }}>
            <div style={{
              fontFamily: F, fontSize: 11, letterSpacing: 3,
              fontWeight: 700, color: '#E8441A', textTransform: 'uppercase',
              marginBottom: 12,
            }}>● DEAL OF THE DAY</div>
            <h3 style={{
              fontFamily: DISPLAY,
              fontSize: 'clamp(32px,4vw,52px)',
              fontWeight: 500,
              color: '#1B3A6B',
              margin: 0,
              lineHeight: 1,
              letterSpacing: -0.02,
            }}>
              Bengaluru → <em style={{ fontStyle: 'italic' }}>Bangkok</em>
            </h3>
            <p style={{
              fontFamily: F,
              fontSize: 16,
              color: '#5C6E8A',
              marginTop: 12,
              lineHeight: 1.5,
            }}>
              Round-trip from <strong style={{ color: '#1B3A6B' }}>₹12,499</strong> · Valid for travel in July &amp; August 2026.
              Book before the clock hits zero.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 24 }}>
              <button
                onClick={() => notYetWiredToast('Deal booking')}
                style={{
                  height: 52, padding: '0 28px', borderRadius: 999,
                  background: '#E8441A', color: '#fff',
                  border: 'none', cursor: 'pointer',
                  fontFamily: F, fontSize: 15, fontWeight: 700,
                  boxShadow: '0 6px 16px rgba(232,68,26,0.25)',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => (e.currentTarget.style.background = '#C53A16')}
                onMouseLeave={e => (e.currentTarget.style.background = '#E8441A')}
              >
                Grab this deal →
              </button>
              <span style={{ fontFamily: F, fontSize: 13, color: '#8C98B0', textDecoration: 'line-through' }}>₹18,500</span>
              <span style={{
                padding: '4px 10px', borderRadius: 999,
                background: '#E8441A', color: '#fff',
                fontFamily: F, fontSize: 11, fontWeight: 700,
              }}>−32%</span>
            </div>
          </div>

          {/* Right: countdown */}
          <div style={{
            flexShrink: 0,
            background: '#fff',
            borderRadius: 24,
            padding: '28px 32px',
            border: '1px solid rgba(232,68,26,0.12)',
            boxShadow: '0 8px 24px rgba(232,68,26,0.08)',
          }}>
            <div style={{
              fontFamily: F, fontSize: 10, letterSpacing: 2,
              fontWeight: 700, color: '#8C98B0', textTransform: 'uppercase',
              textAlign: 'center', marginBottom: 16,
            }}>Expires in</div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Digit value={h} label="hrs" />
              <Colon />
              <Digit value={m} label="min" />
              <Colon />
              <Digit value={s} label="sec" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
